export default __webpack_public_path__ + "static/media/dog-image-3.7d60a08c.jpeg";